
(() => {
  if (window.rbCardAlignment) return;
  window.rbCardAlignment = true;
  const slots = ['vendor', 'title', 'details', 'reviews', 'top-price', 'swatches', 'inventory', 'bottom-price'];
  let frame;
  const align = () => {
    frame = null;
    const cards = [...document.querySelectorAll('product-card')].filter(card => card.querySelector('.rb-card-row') && card.getClientRects().length);
    cards.forEach(card => card.querySelectorAll('.rb-card-row').forEach(row => row.style.minHeight = ''));
    const groups = new Map();
    cards.forEach(card => {
      const parent = card.parentElement;
      const container = parent.tagName === 'LI' ? parent.parentElement : parent;
      if (!groups.has(container)) groups.set(container, []);
      const rows = groups.get(container);
      const top = card.getBoundingClientRect().top;
      let row = rows.find(group => Math.abs(group.top - top) < 3);
      if (!row) { row = { top, cards: [] }; rows.push(row); }
      row.cards.push(card);
    });
    groups.forEach(rows => rows.forEach(group => {
      if (group.cards.length < 2) return;
      slots.forEach(slot => {
        const cells = group.cards.map(card => card.querySelector('.rb-card-row--' + slot));
        const height = Math.max(...cells.map(cell => cell.getBoundingClientRect().height));
        cells.forEach(cell => cell.style.minHeight = height + 'px');
      });
    }));
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  document.fonts.ready.then(schedule);
  schedule();
})();
